import { FC, Fragment } from 'react'
import '../ModalStyle.scss'
import { onKeyDown, validateNumberWithoutDecimal, preventKeyInputs } from '../../../../utils/commonFunctions';
import { SelectedPayloadType } from './QuickDeployModal';
import { showToastMessage } from '../../../../utils/commonFunctions';
import './QuickDeployForm.scss'

interface PayloadProps {
    selectedPayload: SelectedPayloadType | null;
    setSelectedPayload: (payload: SelectedPayloadType) => void;
}
const PayloadForm: FC<PayloadProps> = ({ selectedPayload, setSelectedPayload }) => {

    return (
        <Fragment>
            <div className='w-100 d-flex flex-column gap-3'>
                <span className='payload_labels_text color-white'>{selectedPayload?.name}</span>
            </div >
            <div className='payload_details_container'>
                {selectedPayload && (
                    <div className='quick_deploy__configuration__container__body'>
                        {(selectedPayload?.interfaces?.includes('GPIO') && selectedPayload) &&
                            <div className='quick_deploy__configuration__container__body__section'>
                                <span className='body__section__header__text'>GPIO</span>
                                <div className='configuration__body__container__section'>
                                    <div className='gpio__configuration__form__container'>
                                        <div className='configuration__form__container'>
                                            <span className='configuration__form__label'>Port</span>
                                        </div>
                                        <div className='configuration__form__container flex-row'>
                                            {[1, 2, 3, 4].map(pin => {
                                                return (
                                                    <span key={pin} className='configuration__form__label'>Pin {pin}</span>
                                                )
                                            })}
                                        </div>
                                        <div className='configuration__form__container'>
                                            <span className='configuration__form__label'>Int</span>
                                        </div>
                                    </div>
                                    {[0, 1, 2, 3].map(port => {
                                        return (
                                            <div className='gpio__configuration__form__container'>
                                                <div className='configuration__form__container'>
                                                    <input className='configuration__form__input' placeholder='#' disabled value={port + 1} />
                                                </div>
                                                <div className='configuration__form__container flex-row'>
                                                    {[0, 1, 2, 3].map(pin => {
                                                        return (
                                                            <input className='configuration__form__input' placeholder='#'
                                                                type='number'
                                                                onKeyDown={validateNumberWithoutDecimal}
                                                                value={selectedPayload.gpio?.[port]?.['pin']?.[pin] ?? ''}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const newConfigurations = { ...selectedPayload }
                                                                    if (Number(value) < 0 || Number(value) > 7) return;
                                                                    else if (newConfigurations.gpio && value === '') {
                                                                        newConfigurations.gpio[port]['pin'][pin] = value;
                                                                        setSelectedPayload(newConfigurations);
                                                                    } else if (newConfigurations?.gpio && (!newConfigurations.gpio[port]['pin'].includes(value) && newConfigurations.gpio[port].interrupt !== value) && value?.length <= 1) {
                                                                        newConfigurations.gpio[port]['pin'][pin] = value;
                                                                        setSelectedPayload(newConfigurations);
                                                                    } else if (newConfigurations?.gpio && (newConfigurations?.gpio[port]['pin'].includes(value) || newConfigurations.gpio[port].interrupt === value)) {
                                                                        showToastMessage('info', `${value} already used for this Port`);
                                                                    }
                                                                }}
                                                            />
                                                        )
                                                    })}
                                                </div>
                                                <div className='configuration__form__container'>
                                                    <input className='configuration__form__input' placeholder='#'
                                                        type='number'
                                                        onKeyDown={validateNumberWithoutDecimal}
                                                        value={selectedPayload.gpio?.[port]?.['interrupt'] || ''}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const newConfigurations = { ...selectedPayload }
                                                            if (Number(value) < 0 || Number(value) > 7) return;
                                                            else if (newConfigurations.gpio && value === '') {
                                                                newConfigurations.gpio[port]['interrupt'] = value
                                                                setSelectedPayload(newConfigurations)
                                                            }
                                                            else if (newConfigurations?.gpio && !newConfigurations.gpio[port]['pin'].includes(value) && value?.length <= 1) {
                                                                newConfigurations.gpio[port]['interrupt'] = value
                                                                setSelectedPayload(newConfigurations)
                                                            } else if (newConfigurations?.gpio && newConfigurations.gpio[port]['pin'].includes(value)) {
                                                                showToastMessage('info', `${value} already used for this Port`);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        }
                        {(selectedPayload?.interfaces?.includes('GPIO') && selectedPayload) && <div className='body__section__devider' />}
                        {(selectedPayload?.interfaces?.includes('CAN') && selectedPayload) &&
                            <div className='quick_deploy__configuration__container__body__section'>
                                <span className='body__section__header__text'>Device Path</span>
                                <div className='configuration__body__container__section'>
                                    {[0, 1].map(can => {
                                        const required = can === 0 ? true : false
                                        const key = `canPath${can}`
                                        return (
                                            <div className='configuration__form__container'>
                                                <span className='configuration__form__label'>CAN 0{can + 1} {required ? '*' : ''}</span>
                                                <input required={required} className='configuration__form__input' placeholder='#'
                                                    type='string'
                                                    onKeyDown={(e) => { preventKeyInputs(e, ['+', '-', '.']) }}
                                                    value={selectedPayload[key] || ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, ' ').trimStart();
                                                        if (value.length > 8) return;
                                                        const newConfigurations = { ...selectedPayload }
                                                        newConfigurations[key] = value
                                                        setSelectedPayload(newConfigurations)
                                                    }}
                                                />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        }
                        {(selectedPayload?.interfaces?.includes('UART') && selectedPayload) &&
                            <div className='quick_deploy__configuration__container__body__section'>
                                <div className='configuration__body__container__section'>
                                    {[0, 1].map(uart => {
                                        const key = `uartPath${uart}`
                                        return (
                                            <div className='configuration__form__container'>
                                                <span className='configuration__form__label'>UART 0{uart + 1}</span>
                                                <input className='configuration__form__input' placeholder='#'
                                                    type='string'
                                                    onKeyDown={(e) => { preventKeyInputs(e, ['+']) }}
                                                    value={selectedPayload[key] || ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/[^a-zA-Z0-9\/\- ]/g, '').replace(/\s+/g, ' ').trimStart();
                                                        if (value.length > 8) return;
                                                        const newConfigurations = { ...selectedPayload }
                                                        newConfigurations[key] = value
                                                        setSelectedPayload(newConfigurations)
                                                    }}
                                                />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        }
                        {(selectedPayload?.interfaces?.includes('Ethernet') && selectedPayload) &&
                            <div className='quick_deploy__configuration__container__body__section'>
                                <div className='configuration__body__container__section'>
                                    <div className='configuration__form__container'>
                                        <span className='configuration__form__label'>ETHERNET *</span>
                                        <input className='configuration__form__input' placeholder='0.0.0.0'
                                            type='string'
                                            onKeyDown={onKeyDown}
                                            value={selectedPayload.payloadDeviceIP || ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (!/^[0-9.]*$/.test(value)) return
                                                const parts = value.split('.');
                                                const validIPAddress = (parts.length <= 4) && (parts.every(part => part.length <= 3 && Number(part) >= 0 && Number(part) <= 255));
                                                if (validIPAddress) {
                                                    const newConfigurations = { ...selectedPayload }
                                                    newConfigurations.payloadDeviceIP = e.target.value
                                                    setSelectedPayload(newConfigurations)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                )}
            </div>
        </Fragment>
    )
}
export default PayloadForm